import { Action } from '@ngrx/store';

import { FilterAction, FilterActionTypes } from '@actions/filter.actions';
import { FilterState } from 'state';

const emptyState: FilterState = {
    concepts: null,
    processingList: null,
    rejected: null,
    toDestroy: null,
    tasks: {
        EvaluateDossier: null,
        SubmitDossier: null,
        ReviseDossier: null
    },
    evaluate: null,
    archive: null
};

export function filterReducer(state = emptyState, action: Action): FilterState {
    const specificAction: FilterAction = action as FilterAction;
    switch (specificAction.type) {
        case FilterActionTypes.SetConceptsFilter:
            return { ...state, concepts: specificAction.payload };
        case FilterActionTypes.SetProcessingListFilter:
            return { ...state, processingList: specificAction.payload };
        case FilterActionTypes.SetRejectedFilter:
            return { ...state, rejected: specificAction.payload };
        case FilterActionTypes.SetToDestroyFilter:
            return { ...state, toDestroy: specificAction.payload };
        case FilterActionTypes.SetTaskFilter:
            return { ...state, tasks: { ...state.tasks, [specificAction.taskType]: specificAction.payload } };
        case FilterActionTypes.SetEvaluateFilter:
            return { ...state, evaluate: specificAction.payload };
        case FilterActionTypes.SetArchiveFilter:
            return { ...state, archive: specificAction.payload };
        default:
            return state;
    }
}
